module.exports = __webpack_public_path__ + "img/relaxy-icon.ccbd953b.svg";